import React from "react";
import { Coins, Info } from "lucide-react";

// Transparency note on how credits & referral rewards work. Shown on sign-in,
// Wallet/Prosperity and the Legal/Terms page.
export default function CreditNote({ compact = false }) {
  if (compact) {
    return (
      <p data-testid="credit-note" className="text-[11px] text-sec leading-relaxed">
        <b className="text-brand">How credits work:</b> You earn credits through activity and referrals. Referral rewards are paid <b>only after the people you invite make a purchase</b>, and individuals earn only on purchases. Earned credits are meant to be used inside My Kind for activities — you can also transfer or lend credits to other members. Referral & welcome credits are for in-app use and aren't cashable.
      </p>
    );
  }
  return (
    <div data-testid="credit-note" className="rounded-xl border border-brand/20 bg-brand/5 p-4">
      <div className="flex items-center gap-2 text-brand mb-1.5"><Coins size={15} /><span className="text-[11px] uppercase tracking-widest">How credits work</span></div>
      <ul className="space-y-1.5 text-[12px] text-sec">
        <li className="flex gap-2"><Info size={13} className="text-brand shrink-0 mt-0.5" /> You earn credits through your activity and referrals.</li>
        <li className="flex gap-2"><Info size={13} className="text-brand shrink-0 mt-0.5" /> Referral rewards are paid <b className="text-[var(--rud-text)]">only after the people you invite make a purchase</b> — and individuals earn only on purchases.</li>
        <li className="flex gap-2"><Info size={13} className="text-brand shrink-0 mt-0.5" /> Earned credits are meant to be <b className="text-[var(--rud-text)]">used inside My Kind</b> for activities.</li>
        <li className="flex gap-2"><Info size={13} className="text-brand shrink-0 mt-0.5" /> You can <b className="text-[var(--rud-text)]">transfer or lend</b> credits to other members.</li>
        <li className="flex gap-2"><Info size={13} className="text-brand shrink-0 mt-0.5" /> Referral & welcome credits are for in-app use and aren't cashable.</li>
      </ul>
    </div>
  );
}
